import type { ColumnDef } from "@tanstack/react-table"
import type { IAccountRewardAccruals, IPromoAmount } from "@apis/rewards/types"
import { CurrencyCell, DateCell } from "@utils/table/columnFactories"

export const existingPromosColumns: ColumnDef<IPromoAmount>[] = [
  {
    header: "Promo",
    accessorKey: "promo_name",
  },
  {
    header: "Amount",
    accessorKey: "amount",
  },
]

export const loyaltyProgramHistoryColumns: ColumnDef<IAccountRewardAccruals>[] =
  [
    {
      accessorKey: "invoice_dt",
      header: "Invoice Date",
      cell: (props) => <DateCell {...props} />,
    },
    {
      accessorKey: "invoice_amt",
      header: "Invoice Amount",
      cell: (props) => <CurrencyCell {...props} />,
    },
    {
      header: "Details",
      accessorKey: "accrual_description",
    },
    {
      accessorKey: "loyalty_program_multiplier",
      header: "Reward Multiplier",
      cell: ({ row }) => {
        const rowData = row.original
        return (
          <div>
            {rowData.loyalty_program_multiplier
              ? `${(Number(rowData.loyalty_program_multiplier) * 100).toFixed(2)}%`
              : null}
          </div>
        )
      },
    },
    {
      accessorKey: "accrued_amount",
      header: "Accrual Amount",
      cell: (props) => <CurrencyCell {...props} />,
    },
    {
      accessorKey: "accrued_dt",
      header: "Accrual Date",
      cell: (props) => <DateCell {...props} />,
    },
    {
      accessorKey: "vesting_dt",
      header: "Vesting Date",
      cell: (props) => <DateCell {...props} />,
    },
  ]

export const bonusHistoryColumns: ColumnDef<IAccountRewardAccruals>[] = [
  {
    accessorKey: "accrued_amount",
    header: "Reward",
    cell: (props) => <CurrencyCell {...props} />,
  },
  {
    accessorKey: "accrued_dt",
    header: "Accrual Date",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "vesting_dt",
    header: "Vesting Date",
    cell: (props) => <DateCell {...props} />,
  },
]
